import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-full flex-col gap-y-5" }
const _hoisted_2 = { class: "flex flex-col-reverse gap-3.5 sm:flex-row" }
const _hoisted_3 = { class: "flex w-full gap-3.5 overflow-hidden" }
const _hoisted_4 = { class: "flex gap-3.5" }
const _hoisted_5 = { class: "flex flex-grow flex-col gap-5 pb-5 xl:flex-row" }
const _hoisted_6 = { class: "xl:w-1/3" }
const _hoisted_7 = { class: "grid h-full grid-cols-1 gap-6 sm:grid-cols-2" }
const _hoisted_8 = { class: "h-full min-h-[300px] xl:w-2/3" }

import { ComputedRef, PropType, Ref, computed, ref } from 'vue';
import { BlackDesertItemDetails, BlackDesertItemType } from '@blackdesertmarket/interfaces';
import { ComponentException } from '@/exceptions/component-exception';
import { ItemDetailsDays } from '@/enums/item-details';
import { UseItemDetailsReturn, useItemDetails } from '@/composables/item-details/use-item-details';
import { UseItemTypeReturn, useItemType } from '@/composables/item-type/use-item-type';
import { UseItemIconFetchReturn, useItemIconFetch } from '@/composables/item/use-item-icon-fetch';
import { TranslateKey, useInject } from '@/composables/use-inject';
import ItemDetailsOverviewButton from '@/components/ItemDetails/ItemDetailsOverview/ItemDetailsOverviewButton.vue';
import ItemDetailsOverviewChart from '@/components/ItemDetails/ItemDetailsOverview/ItemDetailsOverviewChart.vue';
import ItemDetailsOverviewProperty from '@/components/ItemDetails/ItemDetailsOverview/ItemDetailsOverviewProperty.vue';
import ListItemIcon from '@/components/ListItem/ListItemIcon.vue';
import ListItemName from '@/components/ListItem/ListItemName.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetailsOverview',
  props: {
  itemType: {
    type: Object as PropType<BlackDesertItemType>,
    required: true,
  },
  itemDetails: {
    type: Object as PropType<BlackDesertItemDetails>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const translate = useInject(TranslateKey);
const itemTypeComposable: UseItemTypeReturn = useItemType(props.itemType);
const itemDetailsComposable: UseItemDetailsReturn = useItemDetails(props.itemDetails);
const itemIconFetch: UseItemIconFetchReturn = useItemIconFetch(props.itemType.id);

const itemGradeText: Ref<string> = ref('');
const itemGradeBorder: Ref<string> = ref('');
const itemIcon: Ref<string> = ref('');

const months: Ref<number> = ref(1);

const days: ComputedRef<number> = computed((): ItemDetailsDays => {
  switch (months.value) {
    case 1:
      return ItemDetailsDays.ONE_MONTH;
    case 3:
      return ItemDetailsDays.THREE_MONTHS;
  }

  throw new ComponentException(`Could not compute days number for ${months.value} months`);
});

const handleButtonClick = (month: number): void => {
  months.value = month;
};

if (props.itemType.grade) {
  itemGradeText.value = `text:item-grade-${props.itemType.grade}`;
  itemGradeBorder.value = `border:item-grade-${props.itemType.grade}`;
}

if (!itemIcon.value) {
  itemIconFetch.fetch().then((icon: string): void => {
    itemIcon.value = icon;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ListItemIcon, {
          src: itemIcon.value,
          item: props.itemType,
          class: _normalizeClass(itemGradeBorder.value)
        }, null, 8, ["src", "item", "class"]),
        _createVNode(ListItemName, {
          name: __props.itemType.name,
          class: _normalizeClass(itemGradeText.value)
        }, null, 8, ["name", "class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ItemDetailsOverviewButton, {
          label: `1 ${_unref(translate)('date.month')}`,
          active: months.value === 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleButtonClick(1)))
        }, null, 8, ["label", "active"]),
        _createVNode(ItemDetailsOverviewButton, {
          label: `3 ${_unref(translate)('date.months')}`,
          active: months.value === 3,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleButtonClick(3)))
        }, null, 8, ["label", "active"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ItemDetailsOverviewProperty, {
            label: _unref(translate)('item.count'),
            value: _unref(itemDetailsComposable).getSellCount()
          }, null, 8, ["label", "value"]),
          _createVNode(ItemDetailsOverviewProperty, {
            label: _unref(translate)('generic.warehouseCapacity'),
            value: ""
          }, null, 8, ["label"]),
          _createVNode(ItemDetailsOverviewProperty, {
            label: _unref(translate)('item.basePrice'),
            value: _unref(itemDetailsComposable).getBasePrice()
          }, null, 8, ["label", "value"]),
          _createVNode(ItemDetailsOverviewProperty, {
            label: _unref(translate)('itemDetails.recentPrice'),
            value: _unref(itemDetailsComposable).getRecentPrice()
          }, null, 8, ["label", "value"]),
          _createVNode(ItemDetailsOverviewProperty, {
            label: _unref(translate)('itemType.tradeCount'),
            value: _unref(itemTypeComposable).getTradeCount()
          }, null, 8, ["label", "value"]),
          _createVNode(ItemDetailsOverviewProperty, {
            label: _unref(translate)('itemDetails.recentTransaction'),
            value: _unref(itemDetailsComposable).getRecentTransaction()
          }, null, 8, ["label", "value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(ItemDetailsOverviewChart, {
          data: props.itemDetails.history,
          days: _unref(days),
          class: "xl:-mt-4"
        }, null, 8, ["data", "days"])
      ])
    ])
  ]))
}
}

})